<template>
  <div class="prizes-2021-game-place">
    <Prizes2021GamePlaceImage />
    <Prizes2021GamePlaceDescription />
  </div>
</template>

<script>
import Prizes2021GamePlaceImage from "./Prizes2021GamePlaceImage";
import Prizes2021GamePlaceDescription from "./Prizes2021GamePlaceDescription";

export default {
  name: "Prizes2021GamePlace",
  components: {
    Prizes2021GamePlaceImage,
    Prizes2021GamePlaceDescription
  }
};
</script>

<style lang="scss">
.prizes-2021-game-place {
  display: flex;
  justify-content: center;
  line-height: normal;
  margin-top: 50px;

  @include breakpoint("xs-only") {
    flex-direction: column;
    justify-content: flex-start;
  }
}
</style>
